import { ElNotification } from 'element-plus'
import { router } from '@/router'
import { getAllUrlParams } from '@/utils/url-params'

export function handleFrom() {
  const query = getAllUrlParams() as any
  if (query.form === 'cascade_child_team') {
    ElNotification({
      title: '已返回本级管理后台',
      message: '由于子级管理后台已退出登录，现在已返回本级管理后台。',
      type: 'warning',
      duration: 0,
    })
    delete query.form
    router.replace({
      path: window.location.pathname,
      query
    })
  }
}
